import React, { useContext } from "react";
import { LangContext } from "../../context/LangContext";
import { Link } from "react-router-dom";
import useFetchData from "../../utils/ApiFetch";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import branchIcon from "../../assets/img/branchIcon.png";
import downloadsIcon from "../../assets/img/downloadsIcon.png";
import faqIcon from "../../assets/img/faqIcon.png";
import touchIcon from "../../assets/img/touchIcon.png";

import facebook from "../../assets/img/socialIcons/facebook.png";
import youtube from "../../assets/img/socialIcons/youtube.png";
import moscutimage from "../../assets/img/moscutimage.png";

import "./footer.css";

const Footer = () => {
  const { state } = useContext(LangContext);
  const np = state.np;
  const { data, loading } = useFetchData("/site_settings");

  const siteSettings = data?.site_settings;

  return (
    <>
      {/* Top Floating Service Box */}
      <div className="OnlineservicesImage tooltip-container">
        <Link to="https://customerportal.primebank.com.np" target="_blank">
          <img
            className="footerTabImage"
            src={moscutimage}
            alt="Online Services"
          />
          <h4>Prime Online Service</h4>
        </Link>
        <span className="tooltip-text">Click for More Info</span>
      </div>

      {/* Footer Tabs */}
      <div className="footerTabsContainer">
        <Link to="/branches" className="footerTabSingleContainer">
          <img src={branchIcon} alt="branch" className="footerTabImage" />
          <p className="footerTabText">
            {np ? "शाखा स्थान" : "Branch Location"}
          </p>
        </Link>

        <Link to="/faq" className="footerTabSingleContainer">
          <img src={faqIcon} alt="faq" className="footerTabImage" />
          <p className="footerTabText">{np ? "कसरी" : "FAQs"}</p>
        </Link>

        <Link to="/downloads" className="footerTabSingleContainer">
          <img src={downloadsIcon} alt="downloads" className="footerTabImage" />
          <p className="footerTabText">{np ? "डाउनलोडहरू" : "Downloads"}</p>
        </Link>

        <Link to="/get-in-touch" className="footerTabSingleContainer">
          <img src={touchIcon} alt="contact" className="footerTabImage" />
          <p className="footerTabText">
            {np ? "सम्पर्कमा रहनुहोस्" : "Get in Touch"}
          </p>
        </Link>
      </div>

      {/* Main Footer */}
      <Box className="FooterMain" component="div">
        <Box className="FLEXBOX container1" component="div">
          {/* Contact Info */}
          <Box className="FootBox" component="div">
            <Typography className="footerListTitle" variant="h4">
              {np ? "सम्पर्कमा रहनुहोस्" : "Get in Touch"}
            </Typography>
            <div className="footerListContainer">
              <p className="footerListItem">
                {np
                  ? "ठेगाना: कमलपोखरी, काठमाडौं"
                  : "Address: KamalPokhari, Kathmandu"}
              </p>
              <p className="footerListItem">
                {np
                  ? "फोन: ०१-४४२३४३२"
                  : "Phone: +977 01-4523254,01-4523432/3 & 01- 4523436"}
              </p>
              <p className="footerListItem">
                {np
                  ? "एनटीसी टोल फ्री नम्बर: १८१०५०००१५०"
                  : "NTC Toll Free Number : 18105000150"}
              </p>
              <p className="footerListItem">
                {np
                  ? "एनसेल टोल फ्री नम्बर : १८१०२४४४५५५"
                  : "Ncell Toll Free Number :18102444555"}
              </p>
              <p className="footerListItem">
                {np ? "हुलाक कोड: 44600" : "Postal Code: 44600"}
              </p>
              <p className="footerListItem">
                {np ? "इमेल: info@pcbl.com.np" : "Email: info@pcbl.com.np"}
              </p>
            </div>

            {/* Social Media Links (Safe) */}
            {!loading && (
              <div className="footerSocialContainer">
                {siteSettings?.facebook && (
                  <a
                    href={siteSettings.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footerSocialItem"
                  >
                    <img
                      src={facebook}
                      alt="Facebook"
                      className="footerSocialImg"
                    />
                  </a>
                )}
                {siteSettings?.youtube && (
                  <a
                    href={siteSettings.youtube}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footerSocialItem"
                  >
                    <img
                      src={youtube}
                      alt="YouTube"
                      className="footerSocialImg"
                    />
                  </a>
                )}
              </div>
            )}
          </Box>

          {/* About Us */}
          <Box className="FootBox" component="div">
            <Typography variant="h4">
              {np ? "हाम्रोबारे" : "About Us"}
            </Typography>
            <div className="footerListContainer">
              <Link to="/about-intro" className="footerListItem">
                {np ? "परिचय" : "Introduction"}
              </Link>
              <Link to="/team-members/27" className="footerListItem">
                {np ? "सञ्चालक समिति" : "Board of Directors"}
              </Link>
              <Link to="/team-members/29" className="footerListItem">
                {np ? "व्यवस्थापन टोली" : "Management Team"}
              </Link>
            </div>
          </Box>

          {/* Support */}
          <Box className="FootBox" component="div">
            <Typography variant="h4">{np ? "समर्थन" : "Support"}</Typography>
            <div className="footerListContainer">
              <Link to="/get-in-touch" className="footerListItem">
                {np ? "हामीलाई सम्पर्क गर्नुहोस" : "Contact Us"}
              </Link>
              <Link to="/downloads" className="footerListItem">
                {np ? "डाउनलोडहरू" : "Downloads"}
              </Link>
              <Link to="/faq" className="footerListItem">
                {np ? "कसरी" : "FAQs"}
              </Link>
              <Link to="/branches" className="footerListItem">
                {np ? "शाखाहरु" : "Branches Location"}
              </Link>
              <Link to="/atms" className="footerListItem">
                {np ? "एटीएम स्थानहरु" : "ATM Location"}
              </Link>
            </div>
          </Box>

          {/* Quick Links */}
          <Box className="FootBox" component="div">
            <Typography variant="h4">
              {np ? "द्रुत पहुँच" : "Quick Links"}
            </Typography>
            <div className="footerListContainer">
              <Link to="/service-charges" className="footerListItem">
                {np ? "शुल्कहरू" : "Tariffs"}
              </Link>
              <Link to="/banking-hours" className="footerListItem">
                {np ? "बैँकिङ्ग समय" : "Banking Hours"}
              </Link>
              <Link to="/public-information" className="footerListItem">
                {np ? "सार्वजनिक जानकारी" : "Public Information"}
              </Link>
              <Link to="/current-vacancy" className="footerListItem">
                {np ? "क्यारियर" : "Career"}
              </Link>
            </div>
          </Box>
        </Box>

        {/* Bottom Copyright */}
        <div className="footerSocialBackground">
          <p className="footerCopyDesc">
            {np
              ? `प्रतिलिपि अधिकार © ${new Date().getFullYear()} प्राइम कमर्शियल बैंक लिमिटेड। सबै अधिकार सुरक्षित।`
              : `Copyright © ${new Date().getFullYear()} Prime Commercial Bank Limited. All Rights Reserved.`}
          </p>
          <p className="footerCopyDesc">
            {np ? "विकसित द्वारा : " : "Developed by : "}
            <a
              href="https://nyatapol.com/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#fff" }}
            >
              {np ? "न्याटापोल प्रविधि" : "Nyatapol Technologies"}
            </a>
          </p>
        </div>
      </Box>
    </>
  );
};

export default Footer;
